"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SceneParcels = void 0;
const validation_1 = require("../../validation");
/** @alpha */
var SceneParcels;
(function (SceneParcels) {
    SceneParcels.schema = {
        description: 'Describes a scene, a set of parcels whose content is treated as the same entity. A list of parcels is listed, for which one of them is considered the "base" for positioning purposes.',
        type: 'object',
        properties: {
            base: {
                type: 'string',
                pattern: '^-?[0-9]+,-?[0-9]+$'
            },
            parcels: {
                type: 'array',
                items: {
                    type: 'string',
                    pattern: '^-?[0-9]+,-?[0-9]+$'
                },
                minItems: 1
            }
        },
        additionalProperties: true,
        required: ['base', 'parcels']
    };
    SceneParcels.schemaValidator = (0, validation_1.generateLazyValidator)(SceneParcels.schema);
    SceneParcels.validate = (sceneParcels) => SceneParcels.schemaValidator(sceneParcels) && sceneParcels.parcels.includes(sceneParcels.base);
})(SceneParcels = exports.SceneParcels || (exports.SceneParcels = {}));
//# sourceMappingURL=scene-parcels.js.map